import * as React from 'react';

export function FullBodyElevation(props: React.SVGProps<SVGSVGElement>) {
	const uid = React.useId();
	const maskA = `${uid}-mask-a`;
	const maskB = `${uid}-mask-b`;

	const { style, ...rest } = props;

	return (
		<svg
			width={30}
			height={58}
			viewBox="0 0 30 58"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			preserveAspectRatio="xMidYMid meet"
			style={{ display: 'block', overflow: 'visible', ...style }}
			{...rest}
		>
			<path
				d="M20.424 14.203a1.633 1.633 0 01.647 1.069 1.61 1.61 0 01-.308 1.208 1.716 1.716 0 01-.777.579c-.13.03-.307.07-.474.098a5.07 5.07 0 01-.994.07c-.67-.022-.911-.166-1.495-.206-.732-.069-.778.126-2.122.318-.871.127-1.75.182-2.63.165-.216-.01-.42-.02-.605-.026l-.021.001c-.261-.022-.503-.039-.688-.057a2.207 2.207 0 01-.86-.378 2.39 2.39 0 01-.944-1.571 2.356 2.356 0 01.46-1.77c.347-.473.85-.81 1.423-.95h.025c.211-.015.404-.029.595-.064a8.163 8.163 0 012.29.15c.597.137 1.258.353 1.258.353.55.187.614.242 1.102.396.467.167.95.284 1.442.347.486.061.979.057 1.464-.012a1.62 1.62 0 011.212.28z"
				fill="#8C8C8C"
			/>

			<path
				d="M20.534 7.623a1.204 1.204 0 011.305.104 1.187 1.187 0 01.426 1.229 26.012 26.012 0 01-1.756 7.65 1.478 1.478 0 01-.704.984 1.587 1.587 0 01-1.715-.14 1.563 1.563 0 01-.563-1.615 9.57 9.57 0 01.816-2.848c.34-.715.591-1 .93-1.724.359-.81.597-1.67.707-2.548a1.127 1.127 0 01.554-1.092z"
				fill="#8C8C8C"
			/>

			<mask
				id={maskA}
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x={18}
				y={1}
				width={7}
				height={8}
			>
				<path d="M19.52 1.718l4.601.789-1.046 5.86-4.6-.789 1.045-5.86z" fill="#fff" />
			</mask>

			<g mask={`url(#${maskA})`}>
				<path
					d="M23.145 3.573c-.175-.017-.249.156-.278.334l-.124 1.112.2-1.8c.029-.14.042-.406-.139-.464-.18-.059-.335.14-.368.36.092-.332.107-.655-.11-.704-.141-.033-.275.066-.32.253l-.33 2.104.282-1.795c.033-.19.016-.435-.156-.464-.173-.03-.275.13-.335.308 0 0-.415 1.533-.457 1.838-.06.324-.195 1.054-.374 1.106-.052-.177-.127-.358-.14-.611-.039-.274-.35-.576-.576-.578-.328.047-.095.55-.062.821.1.833.09 1.228.277 1.702.121.32.208.707.945.932.991.158 1.51-.218 1.97-2.066.097-.412.273-1.818.256-2.083-.01-.164-.047-.294-.161-.305z"
					fill="#8C8C8C"
				/>
			</g>

			<path
				d="M15.363 15.121c.174.401.52 1.36-.202 6.102-.364 2.383-.557 2.813-.458 3.976.075.962.027 1.382.213 2.451.087.502.165.994.19 1.103.256 1.077.208 2.182.057 2.84a3.787 3.787 0 01-2.367 1.65 3.896 3.896 0 01-3.348-.755 8.693 8.693 0 01-.674-.717 6.566 6.566 0 01-1.587-3.193 6.374 6.374 0 01-.024-1.728c.112-.595.264-1.182.455-1.758 0 0 .234-.912.36-1.793.126-.881.043-1.564-.316-3.491-.514-2.756-.664-3.207-.72-3.682 0 0-.03-.204-.03-.39-.05-1.192.63-2.687.699-2.84.528-1.14.745-1.119 1.275-2.368.215-.427.359-.885.426-1.358.11-1.162-.52-1.648-.248-2.115.341-.582 1.686-.493 2.547-.212 1.343.426 2.499 1.667 2.384 2.603a1.295 1.295 0 01-.254.7c-.265.329-.609.326-.775.668a.881.881 0 00-.064.498c.067.573.543.74 1.133 1.42a8.975 8.975 0 011.328 2.39z"
				fill="#8C8C8C"
			/>

			<path
				d="M16.055 5.555c.084.565.116 1.137.096 1.708-.026.426-.08.85-.162 1.27a4.404 4.404 0 01-.416 1.428c-.107.252-.28.47-.504.631a1.742 1.742 0 01-1.336.093 3.067 3.067 0 01-.829-.358c-.371-.21-.421-.312-.84-.59a7.78 7.78 0 00-.925-.515c-.816-.4-.846-.268-1.259-.519a3.122 3.122 0 01-1.174-1.34 4.203 4.203 0 01-.272-1.079 3.759 3.759 0 01.895-2.71 3.858 3.858 0 015.316-.51 3.776 3.776 0 011.407 2.489l.003.002z"
				fill="#BFBFBF"
			/>

			<rect x={18.0554} y={1.8916} width={8.30556} height={5.59722} rx={1.08333} fill="#8C8C8C" />

			<path
				d="M20.492 15.107a1.633 1.633 0 01.647 1.069 1.61 1.61 0 01-.308 1.208 1.716 1.716 0 01-.777.58c-.13.03-.307.07-.474.097a5.07 5.07 0 01-.994.07c-.67-.022-.911-.166-1.495-.205-.732-.07-.778.125-2.122.317a16.1 16.1 0 01-2.63.165c-.216-.01-.42-.02-.605-.026l-.021.002c-.261-.022-.503-.04-.688-.057a2.205 2.205 0 01-.86-.379 2.39 2.39 0 01-.944-1.571 2.356 2.356 0 01.46-1.77c.347-.473.85-.809 1.423-.949l.025-.002c.211-.014.404-.028.595-.063a8.163 8.163 0 012.29.15c.597.137 1.258.354 1.258.354.55.187.614.241 1.102.395.467.167.95.284 1.442.348.486.06.979.056 1.464-.013a1.62 1.62 0 011.212.28z"
				fill="#BFBFBF"
			/>

			<path
				d="M13.343 45.438a1.94 1.94 0 01-1.23.87 2.058 2.058 0 01-1.517-.254 2.13 2.13 0 01-.795-.832 2.044 2.044 0 01-.235-1.11s.017-.019.006-.045l.057-.263.007-.064c.078-.507.11-1.02.097-1.535a9.434 9.434 0 00-.506-2.666 48.084 48.084 0 01-1.28-5.125 18.745 18.745 0 01-.297-3.408.31.31 0 01-.007-.092 4.088 4.088 0 01.02-.498 3.44 3.44 0 01.481-1.528 3.715 3.715 0 012.358-1.679 3.942 3.942 0 012.916.487c.367.22.697.495.98.814.606.751.952 1.67.986 2.618.183 1.699-.018 2.834-.293 5.08-.378 3.115-.241 2.897-.498 4.399-.255 1.5-.608 2.98-1.06 4.429 0 0-.02.023-.016.047a1.706 1.706 0 01-.174.355zM18.01 57.154c-.1.426-.658.596-.944.675-.285.08-.44.068-1.643.041-.35.017-.701.004-1.049-.04-.559-.108-.649-.274-1.205-.422a4.297 4.297 0 00-1.333-.142c-.813.022-.912.22-1.652.194a2.3 2.3 0 01-1.182-.285 1.376 1.376 0 01-.606-.65c-.146-.389.004-.772.306-1.526.134-.33.285-.652.454-.965.073-.172.12-.353.14-.539 0-.172.02-.344.058-.512a.952.952 0 01.387-.44 1.342 1.342 0 011.18-.227 1.34 1.34 0 01.886.804c.404.46.843.89 1.312 1.283.408.324.832.627 1.271.907.357.284.762.504 1.195.65.285.058.574.1.864.123 1.024.143 1.192.211 1.33.361a.783.783 0 01.23.71z"
				fill="#8C8C8C"
			/>

			<path
				d="M13.756 44.847a37.141 37.141 0 01-.464 2.66c-.22 1.053-.403 1.592-.726 2.978a73.445 73.445 0 00-.682 3.084l-.002.043c-.068.32-.254.603-.522.794a1.335 1.335 0 01-1.773-.204 1.3 1.3 0 01-.324-.89c.005-.087.03-.16.041-.236.087-.619.135-1.243.145-1.868a5.851 5.851 0 00-.121-1.703c-.062-.229-.157-.481-.26-.919a6.681 6.681 0 01-.092-.897c-.027-.668.205-2.052.86-3.759a1.99 1.99 0 01.788-1.16 2.029 2.029 0 012.633.252c.334.35.529.807.548 1.288 0 .178-.027.362-.05.537z"
				fill="#8C8C8C"
			/>

			<path
				d="M21.422 7.84a1.204 1.204 0 011.305.104 1.187 1.187 0 01.426 1.228 26.009 26.009 0 01-1.755 7.65 1.478 1.478 0 01-.704.984 1.587 1.587 0 01-1.716-.14 1.563 1.563 0 01-.563-1.614 9.572 9.572 0 01.816-2.849c.34-.714.592-.998.93-1.723.359-.811.597-1.67.707-2.548a1.128 1.128 0 01.554-1.093z"
				fill="#BFBFBF"
			/>

			<mask
				id={maskB}
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x={19}
				y={1}
				width={7}
				height={8}
			>
				<path d="M20.403 1.96l4.601.79-1.046 5.86-4.6-.79 1.045-5.86z" fill="#fff" />
			</mask>

			<g mask={`url(#${maskB})`}>
				<path
					d="M24.028 3.816c-.175-.017-.249.157-.278.334l-.124 1.113.2-1.8c.029-.14.042-.407-.139-.465-.18-.059-.335.14-.368.36.092-.332.107-.655-.11-.704-.141-.032-.275.066-.32.253l-.33 2.105.282-1.796c.033-.19.017-.435-.156-.464-.173-.03-.275.13-.335.309 0 0-.415 1.532-.457 1.837-.06.324-.195 1.054-.374 1.106-.052-.177-.127-.357-.14-.611-.039-.274-.35-.576-.576-.578-.328.047-.095.551-.062.821.1.834.09 1.228.277 1.703.121.32.208.707.945.932.991.157 1.51-.219 1.97-2.066.097-.413.273-1.82.256-2.084-.01-.164-.047-.294-.161-.305z"
					fill="#BFBFBF"
				/>
			</g>
		</svg>
	);
}
